import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppPrice } from '@galaxy/marketplace-apps';

@Component({
  selector: 'store-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.scss'],
  standalone: false,
})
export class VaHeaderContainerComponent {
  @Input() iconUrl: string;
  @Input() title: string;
  @Input() tagline: string;
  @Input() prerequisite: string;
  @Input() chipLabels: string[];
  @Input() appPrice: AppPrice;
  @Input() partnerCurrency = 'USD';
  @Input() loaded = true;
  @Input() hasVerifiedContract: boolean;
  @Input() primaryPricingActionLabel: string;
  @Input() pricingActionLabel: string;
  @Input() pricingActionEnabled: boolean;
  @Input() actionEnabled: boolean;
  @Input() actionLabel: string;
  @Input() showAction: boolean;
  @Input() showPricing: boolean;
  @Input() showEnableAddon = false;
  @Input() prerequisiteLabel: string;
  @Input() hideTags = false;
  @Output() prerequisiteSelected = new EventEmitter();
  @Output() actionSelected = new EventEmitter();
  @Output() primaryPricingActionSelected = new EventEmitter();
  @Output() pricingActionSelected = new EventEmitter();
  @Output() contactActionClick = new EventEmitter<null>();

  onActionSelected(): void {
    this.actionSelected.emit();
  }

  onPrerequisiteSelected(): void {
    this.prerequisiteSelected.emit();
  }

  handleContactActionClick(): void {
    this.contactActionClick.emit();
  }
}
